module.exports = __webpack_public_path__ + "static/media/Eyes_4.47ffec0c.jpg";